var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FadeInTransition',{attrs:{"fadeinTime":"0.5s"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}]},[_vm._t("fadein-slot")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }